/**
 * PRICES DO NOT BELONG IN THIS FILE.
 *
 * These option labels used to advertise flat surcharges (Iron-On +£0.10,
 * Hook Only +£0.25, ...) that contradicted /pages/pricing-guide by up to 18x,
 * because the real add-ons scale with patch size. Nothing here calculates a
 * price - the labels were the whole claim - so they now just name the option.
 *
 * The authoritative model is assets/ee-pricing.js. If this form ever needs to
 * show prices, read them from window.EEPricing, never from a literal.
 */
/**
 * EEQUOTE — Emporium Embroidery Configuration
 * Branch: client/emporium-embroidery
 *
 * New-quote alerts are sent by EE-admin over the Gmail API, not a third party.
 * 2. Enter your email to get a free Access Key
 */

// Alerts go through EE-admin's Gmail integration - see configurator.config.js.
const SUBMIT_URL     = 'https://quote.emporiumembroidery.co.uk/api/quote-submit';

const SUPABASE_URL   = 'https://tnqgexdzhorukbiexjlp.supabase.co';
const SUPABASE_KEY   = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRucWdleGR6aG9ydWtiaWV4amxwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY3NTkyMjEsImV4cCI6MjA5MjMzNTIyMX0.wfhQRipyxEVK3VIvPEts5K4oqhLRaNt5P_LR3qhHVSI';

window.QuoteModuleConfig = {

  title: 'Get a Free Embroidery Quote',
  accentColor: '#B79A5D',

  // Cloudflare Turnstile site key — get yours at dash.cloudflare.com/turnstile
  // Live key. Hostnames are managed in Cloudflare → Turnstile → "EE quote".
  captchaSiteKey: '0x4AAAAAADCcgsf5lB8QTML4',

  steps: {

    /** ── Step 1: Contact Details ─────────────────────────────────── */
    contact: {
      enabled: true,
      heading: 'Your Details',
      fields: {
        firstName: { label: 'First Name',    required: true  },
        lastName:  { label: 'Last Name',     required: true  },
        email:     { label: 'Email Address', required: true  },
        phone:     { label: 'Phone Number',  required: false },
        deadline:  { label: 'Need by Date',  required: false },
        quantity:  { label: 'Quantity',      required: true  },
      }
    },

    /** ── Step 2: Embroidery Coverage ────────────────────────────── */
    product: {
      enabled:     true,
      heading:     'Embroidery Coverage',
      label:       'Coverage Type',
      required:    true,
      multiSelect: false,
      options: [
        {
          id:          '50-percent',
          label:       'Up to 50% Embroidery',
          description: 'Partial coverage — ideal for logos and name patches.',
          image:       'EEQUOTE/assets/embroider-50.png',
        },
        {
          id:          '100-percent',
          label:       'Up to 100% Embroidery',
          description: 'Full coverage — rich, dense embroidery across the entire patch.',
          image:       'EEQUOTE/assets/embroider-100.png',
        },
      ]
    },

    /** ── Step 3: Patch Specifications ──────────────────────────── */
    specs: {
      enabled: true,
      heading: 'Patch Specifications',

      calculator: {
        enabled:     true,
        defaultUnit: 'cm',
        label:       'Patch Dimensions',
      },

      dropdowns: [
        {
          id:       'backing',
          label:    'Backing Type',
          required: true,
          options: [
            'Sew-on (included)',
            'Iron-on',
            'Adhesive',
            'Velcro hook only',
            'Velcro hook and loop',
            'Premium felt sew-on',
          ],
        },
        {
          id:       'border',
          label:    'Border Style',
          required: true,
          options: [
            'Embroidered Border (included)',
            'Merrowed Border',
          ],
        },
        {
          id:       'style',
          label:    'Patch Style',
          required: true,
          options: [
            'Embroidered Patch (standard)',
            'Reflective Patch',
            'Glow In The Dark Patch',
            'Metallic Thread Patch',
            'Leather Style Patch',
            'Felt Style Patch',
            'Camo Style Patch',
          ],
        },
        {
          id:       'colors',
          label:    'Thread Colours',
          required: true,
          options: [
            'Up to 3 colours (included)',
            'Up to 6 colours',
            'Up to 9 colours',
            'Over 9 colours',
          ],
        },
      ]
    },

    /** ── Step 4: Artwork & Notes ────────────────────────────────── */
    upload: {
      enabled:          true,
      heading:          'Artwork & Notes',
      maxSizeMB:        10,
      maxFiles:         5,
      accept:           'image/*,.pdf,.eps,.ai,.svg,.zip',
      acceptLabel:      'EPS, AI, PNG, JPG, PDF, SVG, ZIP — max 10 MB each',
      notesLabel:       'Other Notes',
      notesPlaceholder: 'Shape, special requirements, reference colours, rush order details…',
    },

  },

  /** ── Submission: Supabase DB + Storage, then a Gmail alert via EE-admin ── */
  onSubmit: async function(data) {
    const db = supabase.createClient(SUPABASE_URL, SUPABASE_KEY);

    const coverage = data.product?.[0] === '50-percent'
      ? 'Up to 50% Embroidery'
      : 'Up to 100% Embroidery';

    // 1. Generate ID client-side so we never need to SELECT back
    const quoteId = crypto.randomUUID();

    // Built here, written by the server only after it verifies the Turnstile
    // token. The browser can no longer create a quote row on its own.
    const row = {
        id:           quoteId,
        first_name:   data.contact.firstName,
        last_name:    data.contact.lastName,
        email:        data.contact.email,
        phone:        data.contact.phone    || null,
        deadline:     data.contact.deadline || null,
        quantity:     data.contact.quantity,
        coverage,
        width:        data.specs?.width                    || null,
        height:       data.specs?.height                   || null,
        unit:         data.specs?.unit                     || null,
        backing:      data.specs?.dropdowns?.backing       || null,
        border_style: data.specs?.dropdowns?.border        || null,
        patch_style:  data.specs?.dropdowns?.style         || null,
        colors:       data.specs?.dropdowns?.colors        || null,
        notes:        data.upload?.notes                   || null,
    };

    // 2. Upload artwork files to storage
    const filePaths = [];
    for (const file of (data.upload?.files || [])) {
      const path = `${row.id}/${file.name}`;
      const { error: uploadError } = await db.storage
        .from('quote-files')
        .upload(path, file, { upsert: false });
      if (uploadError) throw new Error(`File upload failed: ${uploadError.message}`);
      filePaths.push(path);
    }

    if (filePaths.length) row.file_paths = filePaths;

    // 3. Server-side: verifies the Turnstile token with Cloudflare, then writes
    //    the row and emails the office. Nothing is saved if the check fails.
    const res = await fetch(SUBMIT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        quoteId,
        turnstileToken: data.turnstileToken,
        turnstileClientReason: data.turnstileClientReason || null,
        hp: data.hp || '',
        quote: row,
      }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      if (res.status === 429) {
        throw new Error('Too many requests from your connection — please wait a few minutes and try again, or call us on 020 3432 5550.');
      }
      throw new Error(err.error === 'Verification failed'
        ? 'Could not verify you are human — please reload the page and try again.'
        : (err.error || 'Could not send your quote. Please try again.'));
    }
  },

};
